import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 3px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 5px;

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;

    h3 {
      font-size: 18px;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.softBlack};
    }

    div {
      display: flex;
      align-items: center;

      button {
        height: 39px;
        width: 39px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        margin-left: 10px;
      }
    }

    button,
    select {
      display: flex;
      align-items: center;
      border: 3px solid ${({ theme }) => theme.colors.lightGrey};
      padding: 8px 12px;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.white};
      color: ${({ theme }) => theme.colors.softBlack};
      transition: background-color 0.2s ease;

      svg {
        font-size: 10px;
      }

      span {
        font-family: 'Sora', sans-serif;
        font-size: 12px;
        font-weight: 600;
        margin-right: 5px;
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.03, theme.colors.white)};
      }
    }

    select {
      font-family: 'Sora', sans-serif;
      font-size: 12px;
      font-weight: 600;
    }
  }

  > main {
    max-height: 746px;
    overflow: hidden;
    overflow-y: auto;
    padding-right: 20px;
    flex: 1;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      -webkit-border-radius: 12px;
      border-radius: 12px;
      background-color: ${({ theme }) => theme.colors.scrollbar};
    }
  }

  > footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding-top: 20px;
    border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
    color: ${({ theme }) => theme.colors.softBlack};
    font-size: 14px;
    margin-top: 20px;

    > strong {
      font-weight: 700;
      display: flex;
      align-items: flex-end;

      svg {
        margin-left: 5px;
      }
    }

    > span {
      font-weight: 400;

      strong {
        display: inline;
      }
    }
  }

  &:nth-child(1) {
    grid-area: 1 / 1 / 3 / 2;
  }

  &:nth-child(2) {
    grid-area: 1 / 2 / 3 / 3;
  }

  &:nth-child(3) {
    grid-area: 1 / 3 / 6 / 4;
  }

  &:nth-child(4) {
    grid-area: 3 / 1 / 6 / 3;
  }

  &:nth-child(5) {
    grid-area: 6 / 1 / 9 / 3;
  }

  &:nth-child(6) {
    grid-area: 6 / 3 / 9 / 4;
  }

  &:nth-child(7) {
    grid-area: 9 / 1 / 12 / 4;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoints.xxl}px) {
    &:nth-child(1) {
      grid-area: 1 / 1 / 3 / 2;
    }

    &:nth-child(2) {
      grid-area: 1 / 2 / 3 / 3;
    }

    &:nth-child(3) {
      grid-area: 3 / 1 / 6 / 2;
    }

    &:nth-child(4) {
      grid-area: 6 / 1 / 9 / 3;
    }

    &:nth-child(5) {
      grid-area: 9 / 1 / 12 / 3;
    }

    &:nth-child(6) {
      grid-area: 3 / 2 / 6 / 3;
    }

    &:nth-child(7) {
      grid-area: 12 / 1 / 15 / 3;
    }
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    &:nth-child(1) {
      grid-area: 1 / 1 / 3 / 2;
    }

    &:nth-child(2) {
      grid-area: 3 / 1 / 5 / 2;
    }

    &:nth-child(3) {
      grid-area: 5 / 1 / 8 / 2;
    }

    &:nth-child(4) {
      grid-area: 11 / 1 / 14 / 2;
    }

    &:nth-child(5) {
      grid-area: 14 / 1 / 17 / 2;
    }

    &:nth-child(6) {
      grid-area: 8 / 1 / 11 / 2;
    }

    &:nth-child(7) {
      grid-area: 17 / 1 / 20 / 2;
    }
  }
`;
